module.exports = __webpack_public_path__ + "img/6s.8426fa9c.png";